export const ROLE_ACTIVE_BRAND_REPORT = 'ROLE_ACTIVE_BRAND_REPORT'
export const ROLE_ADM_BRAND_ACTIONS = 'ROLE_ADM_BRAND_ACTIONS'
export const ROLE_ADS_ALLOWED_REPORT = 'ROLE_ADS_ALLOWED_REPORT'
export const ROLE_ADS_REMOVED_REPORT = 'ROLE_ADS_REMOVED_REPORT'
export const ROLE_ADS_TO_REMOVE_REPORT = 'ROLE_ADS_TO_REMOVE_REPORT'
export const ROLE_BACKOFFICE_ACTIONS = 'ROLE_BACKOFFICE_ACTIONS'
export const ROLE_BRAND_MANAGEMENT = 'ROLE_BRAND_MANAGEMENT'
export const ROLE_COMPLAINT_LIST = 'ROLE_COMPLAINT_LIST'
export const ROLE_COMPLAINT_NEW = 'ROLE_COMPLAINT_NEW'
export const ROLE_CONSULTANT_BRAND_ACTIONS = 'ROLE_CONSULTANT_BRAND_ACTIONS'
export const ROLE_CRUD_USER = 'ROLE_CRUD_USER'
export const ROLE_GENERAL_BRANDS_REPORT = 'ROLE_GENERAL_BRANDS_REPORT'
export const ROLE_INACTIVATE_BRAND = 'ROLE_INACTIVATE_BRAND'
export const ROLE_LEGAL_ACTIONS = 'ROLE_LEGAL_ACTIONS'
export const ROLE_MARCA_PRE_CAD = 'ROLE_MARCA_PRE_CAD'
export const ROLE_MARCA_PRE_CAD_ADMIN = 'ROLE_MARCA_PRE_CAD_ADMIN'
export const ROLE_MARCA_PRE_CAD_CONSULTORIA = 'ROLE_MARCA_PRE_CAD_CONSULTORIA'
export const ROLE_MARCA_PRE_CAD_VINCULO = 'ROLE_MARCA_PRE_CAD_VINCULO'
export const ROLE_NOT_FOUND = 'ROLE_NOT_FOUND'
export const ROLE_PRODUCT_LIST = 'ROLE_PRODUCT_LIST'
export const ROLE_PROMOTE_ADMIN = 'ROLE_PROMOTE_ADMIN'
export const ROLE_REASON_COMPLAINT_MANAGEMENT = 'ROLE_REASON_COMPLAINT_MANAGEMENT'
export const ROLE_REASON_COMPLAINT_NEW = 'ROLE_REASON_COMPLAINT_NEW'
export const ROLE_REGULATORY_AGENCY_MANAGEMENT = 'ROLE_REGULATORY_AGENCY_MANAGEMENT'
export const ROLE_REGULATORY_AGENCY_NEW = 'ROLE_REGULATORY_AGENCY_NEW'
export const ROLE_SEARCH_AWAITING_LEGAL_DOCUMENTATION = 'ROLE_SEARCH_AWAITING_LEGAL_DOCUMENTATION'
export const ROLE_SUB_SPECIFICATION_MANAGEMENT = 'ROLE_SUB_SPECIFICATION_MANAGEMENT'
export const ROLE_SUB_SPECIFICATION_NEW = 'ROLE_SUB_SPECIFICATION_NEW'
export const ROLE_TICKET_GROUPS_REPORT = 'ROLE_TICKET_GROUPS_REPORT'
export const ROLE_TICKET_SLA_REPORT = 'ROLE_TICKET_SLA_REPORT'
export const ROLE_TICKETS_MANAGEMENT = 'ROLE_TICKETS_MANAGEMENT'
export const ROLE_TICKETS_REPORT = 'ROLE_TICKETS_REPORT'
